module.exports = __webpack_public_path__ + "media/images/lb/742-111d416998b5a5737a4ff196557d7bdc.svg";